export class QuoteApprovalSearch {
	public plantNumber: number;
	public pageRequested: number;
	public recordsPerPage: number;
	public retailerNumber: string;
	public quoteStatusID: number;
	public searchString: string;

	constructor() {
		this.plantNumber = null;
		this.pageRequested = null;
		this.recordsPerPage = null;
		this.retailerNumber = null;
		this.quoteStatusID = null;
		this.searchString = null;
	}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/quote-approval-search.ts